import type {TGetInitialDataResponse} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import {GetApi} from '~/api/client'
import globalDataMock from '~/api/endpoints/GetInitialData/mock'

const endpoint = endpoints.core.getInitialData

export default class GetInitialData extends GetApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  public static mockResponseWithMockConfig = () => {
    // TODO eventually configure the response here with MockConfig
    return globalDataMock
  }

  protected getMockResponse(): TGetInitialDataResponse {
    return GetInitialData.mockResponseWithMockConfig()
  }

  protected transformResponse(r: TGetInitialDataResponse) {
    return r
  }

  public mocksRequireLogin() {
    return true
  }
}
